"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARED_FINANCIAL_ACCOUNT = exports.CREDITOR = exports.BANKRUPTCY = exports.CHARITY = exports.PERSONAL = exports.OTHER = exports.AUTOMOBILE = exports.SUPPLIERS = exports.LOAN = exports.CREDIT_CARD = exports.MORTGAGE = void 0; // Creditor

exports.MORTGAGE = "mortgage";
exports.CREDIT_CARD = "credit_card";
exports.LOAN = "loan";
exports.SUPPLIERS = "suppliers"; //Creditor & Held Property
//TODO: do we want these to have a prefix for held property?

exports.AUTOMOBILE = "automobile";
exports.OTHER = "other"; // Contribution

exports.PERSONAL = "personal";
exports.CHARITY = "charity"; // Consultant

exports.BANKRUPTCY = "bankruptcy";
exports.CREDITOR = "creditor"; // Held Property
// Note: held property technically isn't a legal transfer
// Joint or custodial financial accounts

exports.SHARED_FINANCIAL_ACCOUNT = "shared_financial_account";